import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font-awesome/css/all.css'
import App from './App.vue'
import router from './router'
import store from './store'
import * as utils from './store/utils'
import * as APIS from './common/api';
import axios from 'axios'

//全局组件
import Page from 'components/page/Page.vue'
import PageContent from 'components/page/PageContent.vue'
import NavBar from 'components/page/NavBar.vue'
import PageBar from 'components/page/PageBar.vue'
import PageBarItem from 'components/page/PageBarItem.vue'
import Portlet from 'components/portlet/Portlet.vue';
import Pagenation from 'components/table/Pagenation.vue'
import baseTitle from 'components/base-layout/base-title.vue'
// 基础组件
import baseSelect from 'components/base-control/modules/base-select.vue';
import baseAutocomplete from 'components/base-control/modules/base-autocomplete.vue';
import baseString from 'components/base-control/modules/base-string.vue';
import baseCheckbox from 'components/base-control/modules/base-checkbox.vue';
import baseDatePicker from 'components/base-control/modules/base-date-picker.vue';
import baseTimePicker from 'components/base-control/modules/base-time-picker.vue';
import baseRadio from 'components/base-control/modules/base-radio.vue';
import baseUpload from 'components/base-control/modules/base-upload.vue';
import baseButton from 'components/base-control/modules/base-button.vue';
import baseQrcode from 'components/base-control/modules/base-qrcode.vue';
import baseCascader from 'components/base-control/modules/base-cascader.vue';
import baseOSSUpload from 'components/base-control/modules/base-oss-upload.vue';
import baseInputNumber from 'components/base-control/modules/base-input-number.vue';
import uploadFile from 'components/base-control/upload-file.vue';


// 通用组件
import multilineSearch from 'components/functional-control/multiline-search/index.vue';
import multilineTable from 'components/functional-control/multiline-table/index.vue';
import multilineButton from 'components/functional-control/multiline-button/index.vue';
import multilineDialog from 'components/functional-control/multiline-dialog/index.vue';
import multilinePrint from 'components/functional-control/multiline-print/index.vue';
// import multilineUpload from 'components/functional-control/multiline-upload/index.vue';
import { registerMicroApps, start } from 'qiankun';


Vue.component('multiline-print', multilinePrint);
Vue.prototype.$apis = APIS.default;
Vue.prototype.$utils = utils;
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(Element)



Vue.component('base-title', baseTitle);
Vue.component('page', Page);
Vue.component('page-content', PageContent);
Vue.component('nav-bar', NavBar);
Vue.component('page-bar', PageBar);
Vue.component('page-bar-item', PageBarItem);
Vue.component('portlet', Portlet);
Vue.component('pagenation', Pagenation);
Vue.component('base-select', baseSelect);
Vue.component('base-autocomplete', baseAutocomplete);
Vue.component('base-string', baseString);
Vue.component('base-input-number', baseInputNumber);
Vue.component('base-checkbox', baseCheckbox);
Vue.component('base-date-picker', baseDatePicker);
Vue.component('base-time-picker', baseTimePicker);
Vue.component('base-radio', baseRadio);
Vue.component('base-upload', baseUpload);
Vue.component('base-button', baseButton);
Vue.component('multiline-search', multilineSearch);
Vue.component('multiline-table', multilineTable);
Vue.component('multiline-button', multilineButton);
Vue.component('multiline-dialog', multilineDialog);
Vue.component('multiline-print', multilinePrint);
// Vue.component('multiline-upload', multilineUpload);
Vue.component('upload-file', uploadFile);
Vue.component('base-qrcode', baseQrcode);
Vue.component('base-cascader', baseCascader);
Vue.component('base-oss-upload', baseOSSUpload);

// router.beforeEach((to,from,next)=>{
//   // if(to.path !== "/login"){
//   //   if(window.sessionStorage.getItem('userInfo')){//说明用户已经登录了
//   //     next()
//   //   }else{
//   //     next("/login") //如果用户没有登录直接跳转到登录界面进行用户登录
//   //   }
//   // }else{
//   //   next()
//   // }
//   if(to.path.includes('lcscm')) {
//     store.commit('SETLCPAGE', true)
//   } else {
//     store.commit('SETLCPAGE', false)
//   }
//   next()
// })
// let registerAppList = []
// if (window.location.host.includes(".uat.")) {
//   // 非正式环境
//   registerAppList = store.state.LCSCM_UAT_REGISTER_APP_LIST;
// } else {
//   registerAppList = store.state.LCSCM_RPD_REGISTER_APP_LIST;
// }


// registerMicroApps(
//   registerAppList.map(item => ({
//     name: item.activeRule,
//     entry: item.entry,
//     container: '#subApp-lcscm-logic',
//     activeRule: [item.activeRule, (location) => {
//       if(!window[item.initFlag] && location.pathname == '/dashboard') { // 第一次进入首页的时候加载子应用
//         window[item.initFlag] = true
//         return true
//       }
//     }]
//   })))
// start({
//   sandbox: true,
//   singular: false
// })

window.addEventListener('message',e=>{
  // console.log('message e:', e)
  if(e.data == 'toLogin') {
    router.push("/login");
    store.dispatch('logout', store.state.userInfo && store.state.userInfo.id)
  }
  if(e.data && e.data.type == 'QCDOWNLOAD') {
    utils.qcDownload(JSON.parse(e.data.param))
  }
},false)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
